import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-overlay-loader',
  imports: [CommonModule],
  templateUrl: './overlay-loader.component.html',
  styleUrl: './overlay-loader.component.css',
})
export class OverlayLoaderComponent {
  @Input() show: boolean = false;
}
